import { ApolloError } from "@apollo/client";

/**
 * Extract the most specific error message from an Apollo error.
 * Prefers GraphQL error messages over network errors, falls back to a generic message.
 */
export function extractErrorMessage(
  error: ApolloError | Error,
  fallback: string,
): string {
  if ("graphQLErrors" in error && error.graphQLErrors?.length > 0) {
    return error.graphQLErrors[0].message;
  }
  if (error.message) {
    return error.message;
  }
  return fallback;
}
